class HoverMedia extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['item', 'media']
  }

  connectedCallback () {
    super.connectedCallback()

    this.autoplay()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.item?.exists) return

    this.handleMouseEnter = this.handleMouseEnter.bind(this)

    this.els.item.elements.forEach(itemEl => {
      this.listeners.add(itemEl, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(itemEl, 'focus', this.handleMouseEnter)
    })
  }

  autoplay () {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval)
    }

    let currentIndex = 0
    const items = this.els.item.elements

    const playNext = () => {
      const index = parseInt(this.activeMediaIndex) || 0
      currentIndex = (index + 1) % items.length
      this.activeMediaIndex = items[currentIndex].dataset.index
    }

    this.autoplayInterval = setInterval(playNext, 3000)

    this.listeners.add(this, 'mouseenter', () => {
      clearInterval(this.autoplayInterval)
    })

    this.listeners.add(this, 'mouseleave', () => {
      this.autoplayInterval = setInterval(playNext, 3000)
    })
  }

  handleMouseEnter (event) {
    this.activeMediaIndex = event.target.dataset.index
  }

  get activeMediaIndex () {
    return this._activeMediaIndex
  }

  set activeMediaIndex (key) {
    const previousMediaIndex = this._activeMediaIndex || '0'
    this._activeMediaIndex = key

    this.els.item.elements.forEach(itemEl => {
      itemEl.setAttribute('aria-pressed', itemEl.dataset.index === key)
    })

    this.els.media.elements.forEach(mediaEl => {
      const mediaIndex = mediaEl.dataset.mediaIndex

      mediaEl.classList.toggle(
        'sec-HoverMedia_Media-previous',
        mediaIndex === previousMediaIndex,
      )
    })
    this.els.media.elements.forEach(mediaEl => {
      const mediaIndex = mediaEl.dataset.mediaIndex

      mediaEl.setAttribute('aria-hidden', mediaIndex !== key)
    })
  }
}

if (!customElements.get('hover-media')) {
  customElements.define('hover-media', HoverMedia)
}
